document.querySelectorAll('#edutech .card-item').forEach(node => {
  node.addEventListener('click', e => {
    const target = e.target || e.srcElement;
    let targetElm = null;
    if (target.classList.contains('card-item')) {
      targetElm = target.getAttribute('href');
    } else {
      targetElm = target.parentNode.getAttribute('href');
    }
    document.querySelector(targetElm).scrollIntoView({ behavior: 'smooth' });
  });
});
